import React from 'react';
import {View} from 'react-native';

import {InlineFormattedNumber} from '/component/base/FormattedNumber';
import Icon from '/component/base/Icon/Icon';
import ProgressBar from '/component/base/ProgressBar/ProgressBar';
import Text from '/component/base/Text';
import {IncentiveTrip} from '/constant/TestIDs';
import {useTranslation} from '/provider/TranslationProvider';
import testProperties from '/util/testing/testProperties';

import {styles} from './Requirements.style';
import {FrontlineQualifyingVolumeProps} from './Requirements.types';

export const FrontlineQualifyingVolume = ({
  iconColor = '#000',
  fqv = {
    currentVolume: '',
    targetVolume: '',
  },
}: FrontlineQualifyingVolumeProps) => {
  const {ts} = useTranslation('requirements.frontLineQualifyingVolume');
  const {currentVolume, targetVolume} = fqv;

  const numerator = Number(currentVolume);
  const denominator = Number(targetVolume);
  const progress = (numerator / denominator) * 100;
  const isQualified = numerator >= denominator;
  const fqvIcon = isQualified ? 'circle-checkmark-filled' : 'circle';

  return (
    <View>
      <View style={styles.progressBarContainer}>
        <Icon
          name={fqvIcon}
          style={{
            ...styles.circleCheckMarkIcon,
            color: iconColor,
            ...(isQualified
              ? styles.circleCheckedFilledFont
              : styles.circleUnFilledFont),
          }}
          testID={`${IncentiveTrip.itGenerateAggregateFQVIcon}${
            isQualified ? 'checked' : 'unchecked'
          }`}
        />
        <Text
          allowFontScaling
          maxFontSizeMultiplier={2}
          variant="caption"
          // @ts-expect-error TS(2339): Property 'boxTitle' does not exist on type '{ boxe... Remove this comment to see the full error message
          style={styles.boxTitle}
          {...testProperties(IncentiveTrip.itGenerateAggregateFQVLabel)}>
          {ts('fqvDescText', 'Generate')}{' '}
        </Text>
        <InlineFormattedNumber
          textEmphasis="medium"
          value={targetVolume}
          style={styles.fqvText}
          testID={IncentiveTrip.itGenerateAggregateFQVLabelNumber}
        />
        <Text
          allowFontScaling
          maxFontSizeMultiplier={2}
          variant="caption"
          // @ts-expect-error TS(2339): Property 'boxTitle' does not exist on type '{ boxe... Remove this comment to see the full error message
          style={styles.boxTitle}
          {...testProperties(IncentiveTrip.itGenerateAggregateFQVLabelLast)}>
          {' '}
          {ts('fqvText', 'aggregate FQV:')}
        </Text>
      </View>
      <View style={styles.fqvContainer}>
        <ProgressBar
          progress={progress}
          style={{base: {maxWidth: '62%', marginLeft: 25}}}
          testID={IncentiveTrip.itGenerateAggregateFQVProgressBar}
        />
        <Text
          allowFontScaling
          maxFontSizeMultiplier={2}
          style={styles.fqvTextContainer}
          {...testProperties(
            IncentiveTrip.itGenerateAggregateFQVProgressBarValue,
          )}>
          <InlineFormattedNumber
            textEmphasis="medium"
            value={numerator}
            style={styles.fqvText}
          />
          <Text
            allowFontScaling
            maxFontSizeMultiplier={2}
            variant="button"
            emphasis="medium">
            {' / '}
          </Text>
          <InlineFormattedNumber
            textEmphasis="medium"
            value={denominator}
            style={styles.fqvText}
          />
        </Text>
      </View>
    </View>
  );
};
